import physical_LE_switch_640 from '../img/purchase/physical_LE_switch_640.jpg';
import physical_LE_switch_640_webp from '../img/purchase/physical_LE_switch_640.webp';
import physical_LE_switch_1280 from '../img/purchase/physical_LE_switch_1280.jpg';
import physical_LE_switch_1280_webp from '../img/purchase/physical_LE_switch_1280.webp';

import physical_SE_switch_640 from '../img/purchase/physical_SE_switch_640.png';
import physical_SE_switch_640_webp from '../img/purchase/physical_SE_switch_640.webp';
import physical_SE_switch_1280 from '../img/purchase/physical_SE_switch_1280.png';
import physical_SE_switch_1280_webp from '../img/purchase/physical_SE_switch_1280.webp';

import physical_SE_switch2_640 from '../img/purchase/physical_SE_switch2_640.png';
import physical_SE_switch2_640_webp from '../img/purchase/physical_SE_switch2_640.webp';
import physical_SE_switch2_1280 from '../img/purchase/physical_SE_switch2_1280.png';
import physical_SE_switch2_1280_webp from '../img/purchase/physical_SE_switch2_1280.webp';

import physical_SE_ps5_640 from '../img/purchase/physical_SE_ps5_640.png';
import physical_SE_ps5_640_webp from '../img/purchase/physical_SE_ps5_640.webp';
import physical_SE_ps5_1280 from '../img/purchase/physical_SE_ps5_1280.png';
import physical_SE_ps5_1280_webp from '../img/purchase/physical_SE_ps5_1280.webp';

import digital_640 from '../img/purchase/digital_640.jpg';
import digital_640_webp from '../img/purchase/digital_640.webp';
import digital_1280 from '../img/purchase/digital_1280.jpg';
import digital_1280_webp from '../img/purchase/digital_1280.webp';

import digital_switch2_640 from '../img/purchase/digital_switch2_640.jpg';
import digital_switch2_640_webp from '../img/purchase/digital_switch2_640.webp';
import digital_switch2_1280 from '../img/purchase/digital_switch2_1280.jpg';
import digital_switch2_1280_webp from '../img/purchase/digital_switch2_1280.webp';

import logo from '../img/common/hero_logo.png';

const purchaseImageList = [
  logo,
  physical_LE_switch_640,
  physical_LE_switch_640_webp,
  physical_LE_switch_1280,
  physical_LE_switch_1280_webp,

  physical_SE_switch_640,
  physical_SE_switch_640_webp,
  physical_SE_switch_1280,
  physical_SE_switch_1280_webp,

  physical_SE_switch2_640,
  physical_SE_switch2_640_webp,
  physical_SE_switch2_1280,
  physical_SE_switch2_1280_webp,

  physical_SE_ps5_640,
  physical_SE_ps5_640_webp,
  physical_SE_ps5_1280,
  physical_SE_ps5_1280_webp,

  digital_640,
  digital_640_webp,
  digital_1280,
  digital_1280_webp,

  digital_switch2_640,
  digital_switch2_640_webp,
  digital_switch2_1280,
  digital_switch2_1280_webp,
];

document.addEventListener('DOMContentLoaded', function () {
  const imageCache = {};

  function preloadImages() {
    const preloadContainerId = 'preload-container';

    // Create the container if it doesn't exist
    let container = document.getElementById(preloadContainerId);

    if (!container) {
      container = document.createElement('div');
      container.id = preloadContainerId;
      container.classList.add('visually-hidden');
      document.body.appendChild(container);
    } else {
      container.innerHTML = '';
    }

    purchaseImageList.forEach((src) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        imageCache[src] = img;

        // Clone and insert into hidden DOM to guarantee caching
        const domImg = document.createElement('img');
        domImg.src = src;
        container?.appendChild(domImg);
      };
      img.onerror = (error) => {
        console.error(`Failed to load image: ${src}`, error);
      };
    });
  }
  preloadImages();
});

export const countryList = [
  {
    country_name: 'United States of America',
    country_id: 'usa',
    country_cookie: 'en',
  },
  {
    country_name: 'Canada',
    country_id: 'ca',
    country_cookie: 'ca',
  },
];

// NOTE: edition_id MUST include digital or physical in it.
export const editionsList = {
  en: [
    {
      edition_name: 'Physical Limited Edition',
      edition_id: 'physicalLimited',
    },
    {
      edition_name: 'Physical Standard Edition',
      edition_id: 'physicalStandard',
    },
    {
      edition_name: 'Digital Edition',
      edition_id: 'digitalStandard',
    },

    // {
    //   edition_name: 'Digital Deluxe Edition',
    //   edition_id: 'digitalDeluxe',
    // },
    // {
    //   edition_name: 'Digital Standard Edition',
    //   edition_id: 'digitalStandard',
    // },
  ],
  ca: [
    {
      edition_name: 'Physical Limited Edition',
      edition_id: 'physicalLimited',
    },
    {
      edition_name: 'Physical Standard Edition',
      edition_id: 'physicalStandard',
    },
    {
      edition_name: 'Digital Edition',
      edition_id: 'digitalStandard',
    },
  ],
};

export const platformsList = [
  {
    platform_name: 'Nintendo Switch',
    platform_id: 'switch',
    platform_cookie: 'switch',
    digitalOnly: false,
    limitedEdition: true,
    digitalDeluxe: true,
  },
  {
    platform_name: 'Nintendo Switch 2',
    platform_id: 'switch2',
    platform_cookie: 'switch2',
    digitalOnly: false,
    limitedEdition: true,
    digitalDeluxe: true,
  },
  {
    platform_name: 'PlayStation®5',
    platform_id: 'ps5',
    platform_cookie: 'ps5',
    digitalOnly: false,
    limitedEdition: true,
    digitalDeluxe: true,
  },
  {
    platform_name: 'Steam',
    platform_id: 'steam',
    platform_cookie: 'steam',
    digitalOnly: true,
    limitedEdition: false,
    digitalDeluxe: true,
  },
];

export const purchaseLinks = {
  en: {
    switch2: {
      digital: {
        // digitalStandard: {
        //   name: 'Nintendo eShop',
        //   link: 'https://nintendo.com/us/store/products/rune-factory-guardians-of-azuma-nintendo-switch-2-edition-switch-2/',
        // },
        // digitalDeluxe: {
        //   name: 'Nintendo eShop',
        //   link: '',
        // },
      },
      physical: {
        physicalLimited: [
          {
            name: 'Marvelous USA Store',
            link: 'https://marvelous-usa.com/product/muramasa_revenant_blades/',
          },
          {
            name: 'Best Buy',
            link: 'https://www.bestbuy.com/product/muramasa-revenant-blades-limited-edition-nintendo-switch-2/J3R84YL9FZ',
          },
          {
            name: 'Amazon',
            link: 'https://www.amazon.com/dp/B0H4NTQBWB/ref=sr_1_3?crid=2OP220NI4680A&dib=eyJ2IjoiMSJ9.8gr-nTlmyExDowHoYTEUU6AlSKeWMGmyqIeXBJesSb0L5L5EFBS2bbD_J5jWVP-0wMg_MPp8Bk48Mdf07gkuc4nak3_1jxc_LXfNZHiQtNs.8DMvJP-6DjOdUq9yL4wy3J7Z4dN3ZpCGBY1NbkGs3ig&dib_tag=se&keywords=muramasa+revenant+blades&qid=1781042644&sprefix=muramasa+revenant+blad%2Caps%2C168&sr=8-3',
          },
        ],
        physicalStandard: [
          {
            name: 'Marvelous USA Store',
            link: 'https://marvelous-usa.com/product/muramasa_revenant_blades/',
          },
          {
            name: 'Best Buy',
            link: 'https://www.bestbuy.com/product/muramasa-revenant-blades-nintendo-switch-2/J3R84YL9F6',
          },
          {
            name: 'Amazon',
            link: 'https://www.amazon.com/dp/B0H4NHFC89/ref=sr_1_1?crid=2OP220NI4680A&dib=eyJ2IjoiMSJ9.8gr-nTlmyExDowHoYTEUU6AlSKeWMGmyqIeXBJesSb0L5L5EFBS2bbD_J5jWVP-0wMg_MPp8Bk48Mdf07gkuc4nak3_1jxc_LXfNZHiQtNs.8DMvJP-6DjOdUq9yL4wy3J7Z4dN3ZpCGBY1NbkGs3ig&dib_tag=se&keywords=muramasa%2Brevenant%2Bblades&qid=1781041167&sprefix=muramasa%2Brevenant%2Bblad%2Caps%2C168&sr=8-1&th=1',
          },
          // {
          //   name: 'Gamestop',
          //   link: 'https://www.gamestop.com/video-games/nintendo-switch-2/products/rune-factory-guardians-of-azuma---nintendo-switch-2/424981.html',
          // },
          // {
          //   name: 'Target',
          //   link: 'https://www.target.com/p/rune-factory-guardians-of-azuma-nintendo-switch-2/-/A-94711025#lnk=sametab',
          // },
          // {
          //   name: 'Walmart',
          //   link: 'https://www.walmart.com/ip/Rune-Factory-Guardians-of-Azuma-Nintendo-Switch-2/15991910803?classType=REGULAR&athbdg=L1600&from=/search',
          // },
        ],
      },
    },
    switch: {
      digital: {
        // digitalStandard: {
        //   name: 'Nintendo eShop',
        //   link: 'https://nintendo.com/us/store/products/rune-factory-guardians-of-azuma-switch/',
        // },
        // digitalDeluxe: {
        //   name: 'Nintendo eShop',
        //   link: 'https://nintendo.com/us/store/products/rune-factory-guardians-of-azuma-digital-deluxe-edition-switch/',
        // },
      },
      physical: {
        physicalLimited: [
          {
            name: 'Marvelous USA Store',
            link: 'https://marvelous-usa.com/product/muramasa_revenant_blades/',
          },
          {
            name: 'Best Buy',
            link: 'https://www.bestbuy.com/product/muramasa-revenant-blades-limited-edition-nintendo-switch/J3R84YL9F8',
          },
          {
            name: 'Amazon',
            link: 'https://www.amazon.com/dp/B0H4NH233M/ref=sr_1_5?crid=2OP220NI4680A&dib=eyJ2IjoiMSJ9.8gr-nTlmyExDowHoYTEUU6AlSKeWMGmyqIeXBJesSb0L5L5EFBS2bbD_J5jWVP-0wMg_MPp8Bk48Mdf07gkuc4nak3_1jxc_LXfNZHiQtNs.8DMvJP-6DjOdUq9yL4wy3J7Z4dN3ZpCGBY1NbkGs3ig&dib_tag=se&keywords=muramasa%2Brevenant%2Bblades&qid=1781042644&sprefix=muramasa%2Brevenant%2Bblad%2Caps%2C168&sr=8-5&th=1',
          },
        ],
        physicalStandard: [
          {
            name: 'Marvelous USA Store',
            link: 'https://marvelous-usa.com/product/muramasa_revenant_blades/',
          },
          {
            name: 'Best Buy',
            link: 'https://www.bestbuy.com/product/muramasa-revenant-blades-nintendo-switch/J3R84YL95V',
          },
          {
            name: 'Amazon',
            link: 'https://www.amazon.com/dp/B0H4P6P245/ref=sr_1_4?crid=2OP220NI4680A&dib=eyJ2IjoiMSJ9.8gr-nTlmyExDowHoYTEUU6AlSKeWMGmyqIeXBJesSb0L5L5EFBS2bbD_J5jWVP-0wMg_MPp8Bk48Mdf07gkuc4nak3_1jxc_LXfNZHiQtNs.8DMvJP-6DjOdUq9yL4wy3J7Z4dN3ZpCGBY1NbkGs3ig&dib_tag=se&keywords=muramasa+revenant+blades&qid=1781042644&sprefix=muramasa+revenant+blad%2Caps%2C168&sr=8-4',
          },
        ],
      },
    },
    steam: {
      digital: {
        digitalStandard: {
          name: 'steam',
          link: 'https://store.steampowered.com/app/4253770/Muramasa_Revenant_Blades',
        },
        // digitalDeluxe: {
        //   name: 'steam',
        //   link: 'https://store.steampowered.com/app/4253770/Muramasa_Revenant_Blades',
        // },
      },
    },
    ps5: {
      digital: {
        digitalStandard: {
          name: 'PlayStation Store',
          link: 'https://store.playstation.com/en-us/concept/10018932/',
        },
        // digitalDeluxe: {
        //   name: 'PlayStation Store',
        //   link: 'https://store.playstation.com/en-us/concept/10018932/',
        // },
      },
      physical: {
        physicalLimited: [
          {
            name: 'Marvelous USA Store',
            link: 'https://marvelous-usa.com/product/muramasa_revenant_blades/',
          },
          {
            name: 'Best Buy',
            link: 'https://www.bestbuy.com/product/muramasa-revenant-blades-limited-edition-playstation-5/J3R84YL9VK',
          },
          {
            name: 'Amazon',
            link: 'https://www.amazon.com/dp/B0H4NKZL9N/ref=sr_1_6?crid=2OP220NI4680A&dib=eyJ2IjoiMSJ9.8gr-nTlmyExDowHoYTEUU6AlSKeWMGmyqIeXBJesSb0L5L5EFBS2bbD_J5jWVP-0wMg_MPp8Bk48Mdf07gkuc4nak3_1jxc_LXfNZHiQtNs.8DMvJP-6DjOdUq9yL4wy3J7Z4dN3ZpCGBY1NbkGs3ig&dib_tag=se&keywords=muramasa+revenant+blades&qid=1781042644&sprefix=muramasa+revenant+blad%2Caps%2C168&sr=8-6',
          },
        ],
        physicalStandard: [
          {
            name: 'Marvelous USA Store',
            link: 'https://marvelous-usa.com/product/muramasa_revenant_blades/',
          },
          {
            name: 'Best Buy',
            link: 'https://www.bestbuy.com/product/muramasa-revenant-blades-playstation-5/J3R84YL9V9',
          },
          {
            name: 'Amazon',
            link: 'https://www.amazon.com/dp/B0H4NLLCLQ/ref=sr_1_7?crid=2OP220NI4680A&dib=eyJ2IjoiMSJ9.8gr-nTlmyExDowHoYTEUU6AlSKeWMGmyqIeXBJesSb0L5L5EFBS2bbD_J5jWVP-0wMg_MPp8Bk48Mdf07gkuc4nak3_1jxc_LXfNZHiQtNs.8DMvJP-6DjOdUq9yL4wy3J7Z4dN3ZpCGBY1NbkGs3ig&dib_tag=se&keywords=muramasa+revenant+blades&qid=1781042644&sprefix=muramasa+revenant+blad%2Caps%2C168&sr=8-7',
          },
        ],
      },
    },
  },
  ca: {
    switch2: {
      digital: {
        // digitalStandard: {
        //   name: 'Nintendo eShop',
        //   link: 'https://nintendo.com/en-ca/store/products/rune-factory-guardians-of-azuma-nintendo-switch-2-edition-switch-2/',
        // },
        // digitalDeluxe: {
        //   name: 'Nintendo eShop',
        //   link: '',
        // },
      },
      physical: {
        physicalLimited: [],
        physicalStandard: [
          // {
          //   name: 'Amazon.CA',
          //   link: 'https://www.amazon.ca/Rune-Factory-Guardians-Azuma-Nintendo/dp/B0F3KMTVYQ/ref=sr_1_8?dib=eyJ2IjoiMSJ9.bsKthCr-49bfu9Xcyw1Vf7HgnJREHdOHoJlotn2GbjmKbkNlZqTLLby9M1iIesNjCCdyrGrapHu0VVzLUKik-_mgqnaIkXn5-Nu8pYgZsiXitgpC5zoeHa0_FW-1XdCLGbyZW75HVbbiIxGY224LwiKrWTH4siXOYEMXNXdZlvzm6KVpjTT5y-3bvJg3vdidjTv2F6VM9VbjahLTKpk0DbXKfXKAv5bzHh_6iJJzM7qJ1FvHV2sM17G9MV82ZRnKyD9sI__zVJCXijjrjckoaz29PMebvMnzA1s_pNwji7g.DOM3SoqR_GK0_jNMUrZYLtSjl8Ez5H2M9O4te7RuUY4&dib_tag=se&keywords=Xseed+Games&qid=1746041392&sr=8-8',
          // },
          // {
          //   name: 'Gamestop (CA)',
          //   link: 'https://www.gamestop.ca/Switch%202/Games/936002/rune-factory-guardians-of-azuma',
          // },
        ],
      },
    },
    switch: {
      digital: {
        // digitalStandard: {
        //   name: 'Nintendo eShop',
        //   link: 'https://nintendo.com/en-ca/store/products/rune-factory-guardians-of-azuma-switch/',
        // },
        // digitalDeluxe: {
        //   name: 'Nintendo eShop',
        //   link: 'https://nintendo.com/en-ca/store/products/rune-factory-guardians-of-azuma-digital-deluxe-edition-switch/',
        // },
      },
      physical: {
        physicalLimited: [
          // {
          //   name: 'Marvelous-USA Store',
          //   link: '',
          // },
          // {
          //   name: 'GameStop (CA)',
          //   link: 'https://www.gamestop.ca/Switch/Games/926945/rune-factory-guardians-of-azuma-earth-dancer-limited-edition',
          // },
          // {
          //   name: 'VGP.CA',
          //   link: '',
          // },
          // {
          //   name: 'PNP Games Online',
          //   link: '',
          // },
          // {
          //   name: 'Amazon.CA',
          //   link: 'https://www.amazon.ca/Rune-Factory-Guardians-Limited-Nintendo/dp/B0DFDVXDG5/ref=sr_1_1?crid=AF4CPCIQV22R&dib=eyJ2IjoiMSJ9.8wzTTaSJtXVpUG79CKRYUw_bG05U57Q6mQmDSLZumA5pIXbjexyuwXWLz0ErC0b1ySODkhciv6J3KATqtarZ4m8YJdneCl2a0jAU4ngSLy5JLTMn2Xxu_eOO-2eamFyk1Rh056ytYqjYPGPAAenckw.6StQtwJmHfQb8WZfN1Q8gE6rfldFn4pXIncI_W8l7Kg&dib_tag=se&keywords=rune%2Bfactory%2Bguardians%2Bof%2Bazuma&qid=1743622020&sprefix=guardians%2Bof%2Bazuma%2Caps%2C136&sr=8-1&th=1',
          // },
        ],
        physicalStandard: [
          // {
          //   name: 'Marvelous-USA Store',
          //   link: '',
          // },
          // {
          //   name: 'GameStop (CA)',
          //   link: 'https://www.gamestop.ca/Switch/Games/926944/rune-factory-guardians-of-azuma',
          // },
          // {
          //   name: 'VGP.CA',
          //   link: '',
          // },
          // {
          //   name: 'PNP Games Online',
          //   link: '',
          // },
          // {
          //   name: 'Amazon.CA',
          //   link: 'https://www.amazon.ca/dp/B0DFDX7CBH?_encoding=UTF8&ref=cm_sw_r_cp_ud_dp_Y8F0G8C74RFBNHHR492G&ref_=cm_sw_r_cp_ud_dp_Y8F0G8C74RFBNHHR492G&social_share=cm_sw_r_cp_ud_dp_Y8F0G8C74RFBNHHR492G&th=1',
          // },
        ],
      },
    },
    steam: {
      digital: {
        digitalStandard: {
          name: 'steam',
          link: 'https://store.steampowered.com/app/4253770/Muramasa_Revenant_Blades',
        },
        // digitalDeluxe: {
        //   name: 'steam',
        //   link: 'https://store.steampowered.com/app/4253770/Muramasa_Revenant_Blades',
        // },
      },
    },
    ps5: {
      digital: {
        digitalStandard: {
          name: 'PlayStation Store',
          link: 'https://store.playstation.com/en-ca/concept/10018932/',
        },
        // digitalDeluxe: {
        //   name: 'PlayStation Store',
        //   link: 'https://store.playstation.com/en-ca/concept/10018932',
        // },
      },
      physical: {
        physicalLimited: [],
        physicalStandard: [
          // {
          //   name: 'Amazon',
          //   link: 'https://www.amazon.ca/Rune-Factory-Guardians-Azuma-Playstation/dp/B0G4SPT4BJ/',
          // },
        ],
      },
    },
  },
};

export const comingSoon = {
  en: 'Links Coming Soon',
  ca: 'Links Coming Soon',
  uk: 'Links Coming Soon',
  au: 'Links Coming Soon',
  fr: 'Liens bientôt disponibles',
  it: 'Collegamenti presto disponibili',
  de: 'Links bald verfügbar',
  es: 'Enlaces muy pronto',
  br: 'Links em breve',
  mx: 'Próximamente los enlaces',
};

export const switchSoon = {
  en: 'Physical Pre-Orders will be Available Soon!',
  ca: 'Links Coming Soon',
  uk: 'Links Coming Soon',
  au: 'Links Coming Soon',
  fr: 'Liens bientôt disponibles',
  it: 'Collegamenti presto disponibili',
  de: 'Links bald verfügbar',
  es: 'Enlaces muy pronto',
  br: 'Links em breve',
  mx: 'Próximamente los enlaces',
};

export const editionsInfo = {
  en: {
    switch2: {
      physicalLimited: {
        image_640: physical_LE_switch_640,
        image_1280: physical_LE_switch_1280,
        image_640_webp: physical_LE_switch_640_webp,
        image_1280_webp: physical_LE_switch_1280_webp,
        title: '',
        items: [],
      },
      physicalStandard: {
        image_640: physical_SE_switch2_640,
        image_1280: physical_SE_switch2_1280,
        image_640_webp: physical_SE_switch2_640_webp,
        image_1280_webp: physical_SE_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
    },
    switch: {
      physicalLimited: {
        image_640: physical_LE_switch_640,
        image_1280: physical_LE_switch_1280,
        image_640_webp: physical_LE_switch_640_webp,
        image_1280_webp: physical_LE_switch_1280_webp,
        title: '',
        items: [],
      },
      physicalStandard: {
        image_640: physical_SE_switch_640,
        image_1280: physical_SE_switch_1280,
        image_640_webp: physical_SE_switch_640_webp,
        image_1280_webp: physical_SE_switch_1280_webp,
        title: '',
        items: [],
      },
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
    },
    ps5: {
      physicalLimited: {
        image_640: physical_LE_switch_640,
        image_1280: physical_LE_switch_1280,
        image_640_webp: physical_LE_switch_640_webp,
        image_1280_webp: physical_LE_switch_1280_webp,
        title: '',
        items: [],
      },
      physicalStandard: {
        image_640: physical_SE_ps5_640,
        image_1280: physical_SE_ps5_1280,
        image_640_webp: physical_SE_ps5_640_webp,
        image_1280_webp: physical_SE_ps5_1280_webp,
        title: '',
        items: [],
      },
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
    },
    steam: {
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
    },
  },
  ca: {
    switch2: {
      physicalLimited: {
        image_640: physical_LE_switch_640,
        image_1280: physical_LE_switch_1280,
        image_640_webp: physical_LE_switch_640_webp,
        image_1280_webp: physical_LE_switch_1280_webp,
        title: '',
        items: [],
      },
      physicalStandard: {
        image_640: physical_SE_switch2_640,
        image_1280: physical_SE_switch2_1280,
        image_640_webp: physical_SE_switch2_640_webp,
        image_1280_webp: physical_SE_switch2_1280_webp,
        title: '',
        items: [],
      },
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
    },
    switch: {
      physicalLimited: {
        image_640: physical_LE_switch_640,
        image_1280: physical_LE_switch_1280,
        image_640_webp: physical_LE_switch_640_webp,
        image_1280_webp: physical_LE_switch_1280_webp,
        title: '',
        items: [],
      },
      physicalStandard: {
        image_640: physical_SE_switch_640,
        image_1280: physical_SE_switch_1280,
        image_640_webp: physical_SE_switch_640_webp,
        image_1280_webp: physical_SE_switch_1280_webp,
        title: '',
        items: [],
      },
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
    },
    ps5: {
      physicalLimited: {
        image_640: physical_LE_switch_640,
        image_1280: physical_LE_switch_1280,
        image_640_webp: physical_LE_switch_640_webp,
        image_1280_webp: physical_LE_switch_1280_webp,
        title: '',
        items: [],
      },
      physicalStandard: {
        image_640: physical_SE_ps5_640,
        image_1280: physical_SE_ps5_1280,
        image_640_webp: physical_SE_ps5_640_webp,
        image_1280_webp: physical_SE_ps5_1280_webp,
        title: '',
        items: [],
      },
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
    },
    steam: {
      digitalStandard: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
      digitalDeluxe: {
        image_640: digital_640,
        image_1280: digital_1280,
        image_640_webp: digital_640_webp,
        image_1280_webp: digital_1280_webp,
        title: '',
        items: [],
      },
    },
  },
};
